/* eslint-disable max-len */
// This file is auto generated by before-build.js and will be overwritten with each "ionic cap sync/copy"
export const AppVersion = JSON.parse("{\"flavor\":\"DEV\",\"gitHash\":\"83798c3\",\"appVersion\":\"1.0.0\",\"buildTimestamp\":1781856417005}")
